import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

class Index extends React.Component {
  static propTypes = {
    eventlogs: PropTypes.array.isRequired,
    filter: PropTypes.object.isRequired,
    navi: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      userId: props.filter.userId || '',
      dateFrom: props.filter.dateFrom || '',
      dateTo: props.filter.dateTo || '',
    };
  }

  componentDidUpdate(prevProps) {
    const filter = this.props.filter;
    if (
      prevProps.filter.userId !== filter.userId ||
      prevProps.filter.dateFrom !== filter.dateFrom ||
      prevProps.filter.dateTo !== filter.dateTo
    ) {
      this.setState({
        userId: filter.userId || '',
        dateFrom: filter.dateFrom || '',
        dateTo: filter.dateTo || '',
      });
    }
  }

  handleChange = (field) => (e) => {
    this.setState({ [field]: e.target.value });
  };

  handleSearch = (e) => {
    e.preventDefault();
    this.props.actions.searchEventlogs({
      userId: this.state.userId,
      dateFrom: this.state.dateFrom,
      dateTo: this.state.dateTo,
    });
  };

  handleNext = (e) => {
    e.preventDefault();
    if (!this.props.navi.canNext) return;
    this.props.actions.nextPage();
  };

  handlePrev = (e) => {
    e.preventDefault();
    if (!this.props.navi.canPrev) return;
    this.props.actions.prevPage();
  };

  viewDetail = (eventlog) => {
    this.props.actions.receiveEventlog(eventlog);
  };

  render() {
    return (
      <div id="eventlogs-container" className="container-fluid">
        <h3 className="mt-3">イベントログ</h3>
        {this.renderFilters()}
        {this.renderPager('top')}
        {this.renderTable()}
        {this.renderPager('bottom')}
      </div>
    );
  }

  renderFilters() {
    return (
      <div className="">
        <div className="mb-3">
          <div className="d-flex">
            <div className="form-group">
              <label htmlFor="eventlog-user-id">ユーザーID</label>
              <input
                id="eventlog-user-id"
                type="text"
                className="form-control"
                value={this.state.userId}
                onChange={this.handleChange('userId')}
                placeholder="123"
              />
            </div>
            <div className="form-group ml-3">
              <label htmlFor="eventlog-date-from">日時（から）</label>
              <input
                id="eventlog-date-from"
                type="datetime-local"
                className="form-control"
                value={this.state.dateFrom}
                onChange={this.handleChange('dateFrom')}
              />
            </div>
            <div className="form-group ml-3">
              <label htmlFor="eventlog-date-to">日時（まで）</label>
              <input
                id="eventlog-date-to"
                type="datetime-local"
                className="form-control"
                value={this.state.dateTo}
                onChange={this.handleChange('dateTo')}
              />
            </div>
            <div className="form-group text-right ml-3 align-self-end">
              <button className="btn btn-primary" onClick={this.handleSearch}>
                検索
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderPager(position) {
    const canPrev = this.props.navi.canPrev;
    const canNext = this.props.navi.canNext;
    return (
      <div className="d-flex justify-content-end align-items-center my-3">
        <div>
          <a
            href="#!"
            className={'mr-3 ' + (canPrev ? '' : 'text-muted')}
            aria-disabled={!canPrev}
            onClick={this.handlePrev}
          >
            戻る
          </a>
          <a
            href="#!"
            className={canNext ? '' : 'text-muted'}
            aria-disabled={!canNext}
            onClick={this.handleNext}
          >
            次へ
          </a>
        </div>
      </div>
    );
  }

  renderTable() {
    const logs = this.props.eventlogs;
    return (
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th className="text-nowrap">発生日時</th>
              <th className="text-nowrap">ユーザーID</th>
              <th className="text-nowrap">イベント種別</th>
              <th className="text-nowrap">ステータス</th>
              <th>メッセージ</th>
              <th className="text-nowrap" />
            </tr>
          </thead>
          <tbody>
            {logs.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center text-muted"></td>
              </tr>
            ) : (
              logs.map((eventlog, idx) => (
                <tr key={eventlog.ulid || idx}>
                  <td>{formatTimestamp(eventlog.created_at)}</td>
                  <td>{eventlog.user_id}</td>
                  <td>{eventlog.event_type}</td>
                  <td>{eventlog.status}</td>
                  <td className="text-truncate" style={{ maxWidth: 320 }}>
                    <span title={eventlog.message || ''}>
                      {eventlog.message || '-'}
                    </span>
                  </td>
                  <td className="text-right text-nowrap">
                    <a
                      href="#!"
                      className="btn btn-sm btn-outline-secondary"
                      onClick={(e) => {
                        e.preventDefault();
                        this.viewDetail(eventlog);
                      }}
                    >
                      詳細
                    </a>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

const formatTimestamp = (value) => {
  if (value === null || typeof value === 'undefined') return '-';
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format('YYYY/MM/DD HH:mm:ss') : value;
};

export default Index;
